import { SubmenuItemListCombinedProps } from './types';

const usePresenter = (props: SubmenuItemListCombinedProps): SubmenuItemListCombinedProps => {
  return props;
};

export default usePresenter;
